export const MuiDayCalendar = palette => ({
  styleOverrides: {
    weekDayLabel: {
      color: palette.surface.onSurface
    }
  }
})
